import React from "react";
import clsx from "clsx";
import "./Button.scss";

/**
 * Componente Button con diferentes variantes y tamaños
 * @param {Object} props - Props del componente
 * @param {'principal-cta' | 'secundario-cta' | 'secundario' | 'icon' | 'multimedia' | 'danger'} [props.variant='principal-cta'] - Variante visual del botón
 * @param {'small' | 'medium' | 'large'} [props.size] - Tamaño del botón (opcional)
 * @param {boolean} [props.isDisabled=false] - Estado deshabilitado del botón
 * @param {React.ReactNode} props.children - Contenido del botón (texto, iconos, etc.)
 * @param {Function} [props.onClick] - Función a ejecutar al hacer click
 * @param {string} [props.className=''] - Clases CSS adicionales
 * @param {Object} [...props] - Props adicionales del elemento button
 * @returns {JSX.Element} Componente Button
 */
export const Button = ({
  variant = "principal-cta",
  size,
  isDisabled = false,
  children,
  onClick,
  className = "",
  ...props
}) => {
  return (
    <button
      className={clsx(
        "btn-custom",
        `btn-${variant}`,
        size && `btn-${size}`,
        className
      )}
      disabled={isDisabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};
